import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '~/pages/Root/constants';
import browserHistoryEntries from '~/services/BrowserHistoryEntries';

/**
 * Leaves the checkout for the cart without stacking a new cart entry on top of
 * it.
 *
 * Pushing `/cart` leaves the checkout behind it, so the app's native back walks
 * straight into the checkout again and the reader loops between the two
 * screens. Stepping back through the history avoids that — past every entry
 * the checkout's own modals left behind. When nothing known sits behind the
 * checkout (a direct entry, a reload), it swaps itself for the cart instead.
 */
export const useCheckoutBack = () => {
  const navigate = useNavigate();

  return useCallback(() => {
    const steps = browserHistoryEntries.stepsBackToLeave(ROUTES.checkout);

    if (steps) {
      navigate(-steps);
      return;
    }

    navigate(ROUTES.cart, { replace: true });
  }, [navigate]);
};
